import { useQuery } from "@tanstack/react-query";
import roomsService from "services/admin/roomsService";

export const useGetRooms = (queryParams = {}) => {
    return useQuery({
        queryKey: ['rooms', queryParams],
        queryFn: async () => {
            const { data } = await roomsService.getAll(queryParams)
            return data
        }
    })
}